import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { Icon, Spinner } from './ui'

// Solo accesso: gli account degli operatori si creano dal pannello Supabase (Authentication > Users),
// non con una registrazione libera che darebbe a chiunque l'accesso ai ticket
export default function Auth() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    setError(''); setLoading(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError('Email o password errati.')
    setLoading(false)
  }

  const onKey = (e) => { if (e.key === 'Enter') handleSubmit() }

  return (
    <div className="auth">
      <div className="auth-brand">
        <div className="row" style={{ gap: 11 }}>
          <div className="sb-logo"><Icon name="message" size={17} strokeWidth={2.4} /></div>
          <div>
            <div className="sb-name">TicketDesk</div>
            <div className="sb-tag" style={{ color: '#a5b4fc' }}>Assistenza clienti</div>
          </div>
        </div>

        <div>
          <h1 className="auth-headline">Ogni richiesta dei clienti, in un unico posto.</h1>
          <p className="auth-lead">Le email arrivano già trasformate in ticket, assegnate all'operatore giusto e pronte per la risposta.</p>
          <div className="auth-feat"><span className="auth-feat-ico"><Icon name="inbox" size={15} /></span><span>Email delle caselle convertite in ticket in automatico</span></div>
          <div className="auth-feat"><span className="auth-feat-ico"><Icon name="zap" size={15} /></span><span>Assegnazione e notifiche all'operatore della casella</span></div>
          <div className="auth-feat"><span className="auth-feat-ico"><Icon name="lock" size={15} /></span><span>Note interne riservate al team, risposte pubbliche al cliente</span></div>
        </div>

        <div style={{ fontSize: 12, color: '#6b768c' }}>© {new Date().getFullYear()} TicketDesk</div>
      </div>

      <div className="auth-form-wrap">
        <div className="auth-form">
          <h2 className="page-title" style={{ fontSize: 24 }}>Bentornato</h2>
          <p className="page-sub" style={{ marginBottom: 28 }}>Accedi per gestire i ticket</p>

          <label className="field">
            <span className="label">Email</span>
            <input className="input" placeholder="nome@azienda.it" type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={onKey} autoFocus />
          </label>
          <label className="field">
            <span className="label">Password</span>
            <input className="input" placeholder="••••••••" type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={onKey} />
          </label>

          {error && <div className="alert alert-error" style={{ marginBottom: 14 }}><Icon name="alert" size={16} /> {error}</div>}

          <button className="btn btn-primary btn-block" style={{ height: 42, fontSize: 14 }} onClick={handleSubmit} disabled={loading}>
            {loading && <Spinner size={14} />}
            {loading ? 'Attendere…' : 'Accedi'}
          </button>

          <div style={{ textAlign: 'center', marginTop: 22, fontSize: 13, color: 'var(--text-3)' }}>
            Non hai un account? Chiedilo all'amministratore.
          </div>
        </div>
      </div>
    </div>
  )
}
